import { Sheet, SheetContent } from '@e2n/ui';
import { UpdateTermineWrapperProps } from '@/domain/termine/features/UpdateTermin/shared/types';
import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UnsavedChangesDialog } from '@/domain/termine/components/UnsavedChangesDialog/UnsavedChangesDialog';

export function UpdateTermineDesktopWrapper({
  onClose,
  children,
  form,
}: UpdateTermineWrapperProps) {
  const { t } = useTranslation();
  const [showUnsavedChangesDialog, setShowUnsavedChangesDialog] =
    useState(false);

  return (
    <>
      <Sheet
        open
        onOpenChange={() => {
          const hasUnsavedChanges = Object.values(form.state.fieldMeta).some(
            (field) => !field.isDefaultValue,
          );
          if (hasUnsavedChanges) setShowUnsavedChangesDialog(true);
          else onClose();
        }}>
        <SheetContent
          className="p-0 min-w-max min-h-min sm:max-w-114.5"
          removeCloseIcon>
          <Suspense
            fallback={
              <div className="flex flex-col h-screen gap-4 items-center justify-center text-sm">
                <FontAwesomeIcon
                  icon={faSpinnerThird}
                  className="text-primary-blue-200"
                  spin
                  size="4x"
                />
                {t('actions.loading')}
              </div>
            }>
            {children}
          </Suspense>
        </SheetContent>
      </Sheet>

      <UnsavedChangesDialog
        open={showUnsavedChangesDialog}
        onCancel={() => setShowUnsavedChangesDialog(false)}
        onConfirm={() => {
          form.reset();
          setShowUnsavedChangesDialog(false);
          onClose();
        }}
      />
    </>
  );
}
